import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { HoverButton } from 'components/common/material-ui/custom-components';
import { formatVideoIframeUrl } from 'libs/common/utils';
import { EditIcon, HoverButtonContainer, PreviewContainer, SelectedVideoContainer, TrashIcon, VideoHover, VideoIframe } from './VideoPreview.style';

var isValidUrl = function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

var VideoPreview = function VideoPreview(_ref) {
  var title = _ref.title,
      iframeUrl = _ref.iframeUrl,
      editFormattedMessage = _ref.editFormattedMessage,
      onReplaceButtonClick = _ref.onReplaceButtonClick,
      onDeleteButtonClick = _ref.onDeleteButtonClick;

  if (iframeUrl === undefined || !isValidUrl(iframeUrl.trim())) {
    return __jsx(React.Fragment, null);
  }

  return __jsx(PreviewContainer, null, __jsx(SelectedVideoContainer, null, __jsx(VideoIframe, {
    src: formatVideoIframeUrl(iframeUrl.trim()),
    "data-testid": "video-player-iframe"
  }), __jsx("p", null, title)), __jsx(VideoHover, null, __jsx(HoverButtonContainer, null, __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(EditIcon, null),
    onClick: onReplaceButtonClick
  }, __jsx(FormattedMessage, {
    id: editFormattedMessage
  })), onDeleteButtonClick && __jsx(HoverButton, {
    color: "primary",
    variant: "outlined",
    startIcon: __jsx(TrashIcon, null),
    onClick: onDeleteButtonClick
  }, __jsx(FormattedMessage, {
    id: "video-preview.delete"
  })))));
};

export default VideoPreview;